function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { ERROR_CODES } from "../types";
import { Validators } from ".";
import { isErrorObject, isHttpError, isParsingError } from "./validators";
export var NeruError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(NeruError, Error1);
    var _super = _create_super(NeruError);
    function NeruError(error, description) {
        _class_call_check(this, NeruError);
        var _this;
        var errorMessage = "";
        if (typeof error === "string") {
            errorMessage = error;
        } else if ("message" in error && typeof error.message === "string") {
            errorMessage = error.message;
        }
        _this = _super.call(this, errorMessage ? "".concat(description, ": ").concat(errorMessage) : description);
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.unknown);
        _define_property(_assert_this_initialized(_this), "rawErrorMessage", "");
        _this.rawErrorMessage = errorMessage !== null && errorMessage !== void 0 ? errorMessage : description;
        return _this;
    }
    return NeruError;
}(_wrap_native_super(Error));
export var UnknownError = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(UnknownError, NeruError);
    var _super = _create_super(UnknownError);
    function UnknownError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, UnknownError);
        return _super.call(this, message, "Something went wrong");
    }
    return UnknownError;
}(NeruError);
export var InvalidRequest = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(InvalidRequest, NeruError);
    var _super = _create_super(InvalidRequest);
    function InvalidRequest() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, InvalidRequest);
        var _this;
        _this = _super.call(this, message, "Bad request");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.invalid);
        return _this;
    }
    return InvalidRequest;
}(NeruError);
export var AccessDenied = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(AccessDenied, NeruError);
    var _super = _create_super(AccessDenied);
    function AccessDenied() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, AccessDenied);
        var _this;
        _this = _super.call(this, message, "Request is not allowed");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.denied);
        return _this;
    }
    return AccessDenied;
}(NeruError);
export var Conflict = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(Conflict, NeruError);
    var _super = _create_super(Conflict);
    function Conflict() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, Conflict);
        var _this;
        _this = _super.call(this, message, "Conflict");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.conflict);
        return _this;
    }
    return Conflict;
}(NeruError);
export var Forbidden = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(Forbidden, NeruError);
    var _super = _create_super(Forbidden);
    function Forbidden() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, Forbidden);
        var _this;
        _this = _super.call(this, message, "Your session is not valid or expired");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.forbidden);
        return _this;
    }
    return Forbidden;
}(NeruError);
export var NotFound = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(NotFound, NeruError);
    var _super = _create_super(NotFound);
    function NotFound() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, NotFound);
        var _this;
        _this = _super.call(this, message, "The resource does not exist");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.notFound);
        return _this;
    }
    return NotFound;
}(NeruError);
export var RateLimit = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(RateLimit, NeruError);
    var _super = _create_super(RateLimit);
    function RateLimit() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, RateLimit);
        var _this;
        _this = _super.call(this, message, "Limit exceeded");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.rateLimit);
        return _this;
    }
    return RateLimit;
}(NeruError);
export var PaymentRequired = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(PaymentRequired, NeruError);
    var _super = _create_super(PaymentRequired);
    function PaymentRequired() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, PaymentRequired);
        var _this;
        _this = _super.call(this, message, "Payment required");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.paymentRequired);
        return _this;
    }
    return PaymentRequired;
}(NeruError);
export var InternalServerError = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(InternalServerError, NeruError);
    var _super = _create_super(InternalServerError);
    function InternalServerError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, InternalServerError);
        var _this;
        _this = _super.call(this, message, "Server issue");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.internalServerError);
        return _this;
    }
    return InternalServerError;
}(NeruError);
export var GatewayTimeout = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(GatewayTimeout, NeruError);
    var _super = _create_super(GatewayTimeout);
    function GatewayTimeout() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, GatewayTimeout);
        var _this;
        _this = _super.call(this, message, "Communication failed due to timeout");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.gatewayTimeout);
        return _this;
    }
    return GatewayTimeout;
}(NeruError);
export var NotImplemented = /*#__PURE__*/ function(NeruError) {
    "use strict";
    _inherits(NotImplemented, NeruError);
    var _super = _create_super(NotImplemented);
    function NotImplemented() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, NotImplemented);
        var _this;
        _this = _super.call(this, message, "Cannot fulfill the request");
        _define_property(_assert_this_initialized(_this), "code", ERROR_CODES.notImplemented);
        return _this;
    }
    return NotImplemented;
}(NeruError);
var HttpCodesMap = new Map([
    [
        400,
        ERROR_CODES.invalid
    ],
    [
        401,
        ERROR_CODES.denied
    ],
    [
        403,
        ERROR_CODES.forbidden
    ],
    [
        402,
        ERROR_CODES.paymentRequired
    ],
    [
        404,
        ERROR_CODES.notFound
    ],
    [
        409,
        ERROR_CODES.conflict
    ],
    [
        429,
        ERROR_CODES.rateLimit
    ],
    [
        500,
        ERROR_CODES.internalServerError
    ],
    [
        501,
        ERROR_CODES.notImplemented
    ],
    [
        502,
        ERROR_CODES.badGateway
    ],
    [
        504,
        ERROR_CODES.gatewayTimeout
    ]
]);
var ErrorCodes = new Map([
    [
        ERROR_CODES.conflict,
        Conflict
    ],
    [
        ERROR_CODES.denied,
        AccessDenied
    ],
    [
        ERROR_CODES.forbidden,
        AccessDenied
    ],
    [
        ERROR_CODES.internalServerError,
        InternalServerError
    ],
    [
        ERROR_CODES.badGateway,
        InternalServerError
    ],
    [
        ERROR_CODES.gatewayTimeout,
        GatewayTimeout
    ],
    [
        ERROR_CODES.notImplemented,
        NotImplemented
    ],
    [
        ERROR_CODES.invalid,
        InvalidRequest
    ],
    [
        ERROR_CODES.notFound,
        NotFound
    ],
    [
        ERROR_CODES.paymentRequired,
        PaymentRequired
    ],
    [
        ERROR_CODES.rateLimit,
        RateLimit
    ]
]);
export var getErrorClass = function(data) {
    if (!data || !isErrorObject(data)) return;
    if (_instanceof(data, NeruError)) return data;
    var response = data.response;
    if (isParsingError(response)) {
        var _error_extensions;
        var error = response.errors[0];
        return constructError(error.message, (_error_extensions = error.extensions) === null || _error_extensions === void 0 ? void 0 : _error_extensions.code);
    } else if (isHttpError(response)) {
        var _response_error, _ref;
        return constructError((_ref = (_response_error = response.error) !== null && _response_error !== void 0 ? _response_error : response.message) !== null && _ref !== void 0 ? _ref : response["error-code-label"], response.code);
    }
    return constructError(data.message);
};
var constructError = function() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", code = arguments.length > 1 ? arguments[1] : void 0;
    var ErrorClass;
    if (code) {
        if (Validators.isNumber(code)) {
            var errorCode = HttpCodesMap.get(code);
            if (errorCode) {
                ErrorClass = ErrorCodes.get(errorCode);
            }
        } else {
            ErrorClass = ErrorCodes.get(code);
        }
        if (ErrorClass) {
            return new ErrorClass(message);
        }
    }
    return new UnknownError(message);
};

//# sourceMappingURL=errors.js.map